import axios from 'axios'
import { backendURL } from '../config.js'

export const fetchSurveyDataByToken = async token => {
    const response = await axios.get(backendURL + '/api/v1/surveys/print/' + token)
    return response.data
}